// extracted by mini-css-extract-plugin
export var answer = "index-module--answer--97c62";
export var faqs_container = "index-module--faqs_container--a0639";
export var question = "index-module--question--b4571";